function ColorSwatchIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="64"
                  fill="none"
                  viewBox="0 0 65 64"
            >
                  <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M27.166 12v36c0 2.88-1.173 5.52-3.04 7.44l-.106.107c-.24.24-.507.48-.747.666a9.33 9.33 0 01-2.64 1.6c-.293.134-.587.24-.88.347-1.04.347-2.16.507-3.253.507-.72 0-1.44-.08-2.134-.214-.346-.08-.693-.16-1.04-.266a9.622 9.622 0 01-1.226-.454c0-.026 0-.026-.027 0a13.44 13.44 0 01-2.133-1.306l-.027-.027a7.32 7.32 0 01-.96-.853c-.293-.32-.587-.64-.88-.987a13.44 13.44 0 01-1.307-2.133c.027-.027.027-.027 0-.027 0 0 0-.027-.026-.053-.16-.374-.294-.774-.427-1.174-.107-.346-.187-.693-.267-1.04A11.348 11.348 0 015.833 48V12c0-4 2.667-6.667 6.667-6.667h8c4 0 6.666 2.667 6.666 6.667z"
                  ></path>
                  <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M59.167 44v8c0 4-2.667 6.667-6.667 6.667h-36c1.093 0 2.213-.16 3.253-.507.294-.107.587-.213.88-.347a9.33 9.33 0 002.64-1.6c.24-.186.507-.426.747-.666l.107-.107L42.26 37.333H52.5c4 0 6.667 2.667 6.667 6.667zM13.327 58.187c-1.6-.48-3.12-1.36-4.373-2.64a10.227 10.227 0 01-2.64-4.374 10.719 10.719 0 007.013 7.014z"
                  ></path>
                  <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M49.487 30.107l-7.227 7.226L24.127 55.44a10.686 10.686 0 003.04-7.44V22.24l7.227-7.227c2.826-2.826 6.613-2.826 9.44 0l5.653 5.654c2.827 2.826 2.827 6.613 0 9.44zM16.5 50.667a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z"
                  ></path>
            </svg>
      );
}

export default ColorSwatchIcon;
